import React from 'react'
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import DashboardTilesContainer from '../../components/DashboardTiles/DashboardTilesContainer';

class DashboardTiles extends React.Component {

  render() {
    return (<Container fluid={true}>
      <DashboardTilesContainer {...this.props} />
    </Container>
    );
  }
}

export default DashboardTiles;